import { Button } from "@ciq/shared/components/buttons"
import { LeftPaneDataProvider, useLeftPaneData } from "./useLeftPaneData"
import { SemesterSelector } from "../semesterSelector"
import { DatasetModule } from "./datasetModule"
import { ViewsModule } from "./viewsModule"
import { CampusFlowModule } from "./campusFlowModule"
import { SelectedInventoryModule } from "./selectedInventoryModule"
import React, { useMemo } from "react"
import { useSearchQueryParams } from "../../../../hooks/search_query_params"
import { useFilterQueryParams } from "../../hooks/filter_query_params"
import { isEmptyArray } from "@ciq/shared/utils/array"
import { ListView } from "@ciq/shared/components/list"
import { useAnalyticsContext } from "@ciq/shared/contexts/AnalyticsContext"
import { FeatureFlags, CAMPUS_FLOW_DISABLED_SCHOOL_IDS } from "@ciq/shared/constants/featureFlags"
import { useAppContext } from "@ciq/shared/hooks/context"

export function MapLeftPane() {
  return (
    <LeftPaneDataProvider>
      <div className="map-pane-left">
        <ListView>
          <Header />
          <DatasetModule />
          <ViewsModule />
          <CampusFlowGated />
          <SelectedInventoryModule />
        </ListView>
        <Footer />
      </div>
    </LeftPaneDataProvider>
  )
}

function Header() {
  return (
    <>
      <SemesterSelector />
    </>
  )
}

function CampusFlowGated() {
  const { isFeatureEnabled } = useAnalyticsContext()
  const { school } = useAppContext()
  if (CAMPUS_FLOW_DISABLED_SCHOOL_IDS.has(school?.id)) return null
  if (!isFeatureEnabled(FeatureFlags.campus_flow)) return null
  return <CampusFlowModule />
}

function Footer() {
  const { footer } = useLeftPaneData()

  const { isSearching } = useSearchQueryParams()
  const { buildings, floors, usages } = useFilterQueryParams()

  const hasChanges = useMemo(() => {
    return isSearching || !isEmptyArray(buildings) || !isEmptyArray(floors) || !isEmptyArray(usages)
  }, [isSearching, buildings, floors, usages])

  return (
    <div className="map-pane-footer">
      <Button variant="secondary" onClick={footer.clearAllFilters} disabled={!hasChanges}>
        Clear All Filters
      </Button>
    </div>
  )
}
